<gp-card [hasError]="hasError">
  <h3 card-title>{{ metadata.name }}</h3>
  <ng-container card-body class="table-responsive">
    <gp-sdc-person-data-items [standardFields]="standardFields"
                              [additionalFields]="additionalFields"
                              [dated]="dated"
                              [data]="data"
                              [expandAll]="expandAll"></gp-sdc-person-data-items>
    <ng-content></ng-content>
  </ng-container>
</gp-card>
